<script lang="ts" setup>
import { useAsyncData } from '@/hooks/async-data';
import { $fetch } from '@/plugins/fetch';

const { data: listing } = useAsyncData('insight:index', () => $fetch('/insight/issue/v1/station'));
</script>

<template>
  <main class="page-insight bg-white pb-[160px] <md:pb-64">
    <section class="page-insight-banner h-[406px] w-full <md:h-240 <md:flex <md:items-center">
      <div class="container mx-auto pt-[146px] text-[#2d2d2d] <md:py-0 <sm:px-16 <xl:px-24">
        <h1 class="mt-0 h-70px text-[50px] font-medium leading-70px <md:h-auto <md:text-28 <md:leading-36">开源态势洞察</h1>
      </div>
    </section>

    <ul class="container mt-45px flex flex-wrap list-none p-0 <md:mt-32 <sm:px-16 <xl:px-24">
      <li class="insight-card mb-36px mr-24px h-344px w-384px rounded-4px duration-200 ease-linear <md:mb-24 <md:mr-0 <md:h-auto <md:w-full hover:translate-y--12px" v-for="item in listing" :key="item.issueId">
        <RouterLink :to="`/insight/issue/${item.issueId}`" class="block no-underline">
          <div class="insight-title h-168px w-full overflow-hidden pb-26px pl-16px pt-48px">
            <span class="line-clamp-1 block text-16px color-hex-ffffff font-400 leading-22px">{{ item.issueNumber }}</span>
            <h3 class="m-0 mt-8px text-24px color-hex-ffffff font-500 leading-36px">{{ item.title }}</h3>
            <p class="m-0 mt-8px mt-8px text-16px color-hex-ffffff font-500 leading-20px">{{ item.releaseDate }}</p>
          </div>
          <div class="h-176px w-full p-24px pt-16px">
            <h3 class="m-0 text-24px color-hex-3d3d3d font-500 leading-36px">{{ item.title }}</h3>
            <p class="line-clamp-4 m-0 mt-px text-justify text-16px color-hex-9a9ea6 font-400 leading-24px">
              {{ item.intro }}
            </p>
          </div>
        </RouterLink>
      </li>
    </ul>
  </main>
</template>

<style lang="scss" scoped>
.page-insight {
  .page-insight-banner {
    background: url(@/assets/insight/banner.png) no-repeat;
    background-position: center;
    background-size: cover;
  }

  @media (max-width: 767.9px) {
    .page-insight-banner {
      text-align: center;
      background: linear-gradient(160deg, #eaf2ff, #f5f7fa);
    }
  }

  .insight-card {
    border: 1px solid rgba(154, 158, 166, 0.1);
    box-shadow: 0 0 16px 0 rgba(0, 0, 0, 0.04);

    .insight-title {
      background: url(@/assets/insight/bg.png) no-repeat;
      background-position: center;
      background-size: cover;
    }

    &:nth-child(3n) {
      margin-right: 0;
    }
  }
}
</style>
